import { z } from 'zod';
import { entityNameSchema } from './org';
import { workspaceRoleSchema } from './permissions';

const timestamp = z.iso.datetime({ offset: true });

/** A row of public.workspaces. */
export const workspaceSchema = z.object({
  id: z.uuid(),
  organization_id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  archived_at: timestamp.nullable(),
  created_at: timestamp,
});
export type Workspace = z.infer<typeof workspaceSchema>;

/** A row of public.workspace_grants. `workspace_id` null means every workspace of the org. */
export const workspaceGrantSchema = z.object({
  id: z.uuid(),
  organization_id: z.uuid(),
  workspace_id: z.uuid().nullable(),
  user_id: z.uuid(),
  scope: z.literal('workspace'),
  role: workspaceRoleSchema,
  created_at: timestamp,
});
export type WorkspaceGrant = z.infer<typeof workspaceGrantSchema>;

/** Input for create_workspace and rename_workspace. */
export const createWorkspaceInputSchema = z.object({ name: entityNameSchema });
export type CreateWorkspaceInput = z.infer<typeof createWorkspaceInputSchema>;
